import { render, staticRenderFns } from "./ConferenciaAprovar.vue?vue&type=template&id=d4a718f0"
import script from "./ConferenciaAprovar.vue?vue&type=script&lang=js"
export * from "./ConferenciaAprovar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports